import clsx from 'clsx';
import React from 'react';

interface AlertProps {
  status: 'success' | 'error';
}

const Alert: React.FC<AlertProps> = ({ status, children }) => {
  const classes = clsx('text-center w-full p-4 text-lg rounded', {
    'bg-red-200 text-red-500': status === 'error',
    'bg-accent-light text-accent': status === 'success',
  });

  return (
    <div data-cy="alert" className={classes}>
      {children}
    </div>
  );
};

export default Alert;
